const TIME_ZONE_SUFFIX = /(Z|[+-]\d{2}:?\d{2})$/i;

const getTimeZoneSuffix = (value: string) =>
  value.trim().match(TIME_ZONE_SUFFIX)?.[1] ?? null;

const parseServerDateTime = (value: string, fallbackTimeZone: string) => {
  const normalizedValue = value.trim();
  const timestamp = Date.parse(
    getTimeZoneSuffix(normalizedValue)
      ? normalizedValue
      : `${normalizedValue}${fallbackTimeZone}`,
  );

  return Number.isFinite(timestamp) ? timestamp : null;
};

export const formatStepScheduleCountdown = (
  nextScheduledAt?: string | null,
  serverNow?: string | null,
  elapsedMilliseconds = 0,
) => {
  if (!nextScheduledAt || !serverNow) return "-";

  // EF may return NextScheduledAt without an offset while ServerNow contains the
  // server offset. Apply one shared offset to timezone-less values so the result
  // never depends on the browser's local timezone.
  const sharedTimeZone =
    getTimeZoneSuffix(serverNow) ?? getTimeZoneSuffix(nextScheduledAt) ?? "Z";
  const nextTimestamp = parseServerDateTime(nextScheduledAt, sharedTimeZone);
  const serverTimestamp = parseServerDateTime(serverNow, sharedTimeZone);

  if (nextTimestamp == null || serverTimestamp == null) return "-";

  const remaining = nextTimestamp - (serverTimestamp + elapsedMilliseconds);
  if (!Number.isFinite(remaining) || remaining <= 0) return "-";

  const totalSeconds = Math.floor(remaining / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [hours, minutes, seconds]
    .map((value) => value.toString().padStart(2, "0"))
    .join(":");
};
